module.exports = __webpack_public_path__ + "static/media/testing-green.b3936a61.svg";